import { Link, useLocation } from 'react-router-dom';
import { deleteFromStorage, logoutHelper } from '../../utils/Helper';
import { StorageConstants } from '../../constants/Constants';
import { Config } from '../../config/Config';
import { FormattedMessage, useIntl } from 'react-intl';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  salonOwnerNeedsSubscription,
  salonOwnerSubscriptionFeatureLocked,
  salonOwnerSubscriptionSuspended,
} from '../../utils/subscriptionAccess';



const Sidebar = () => {
  const { pathname } = useLocation();
  const role_id = Config?.USER_DETAILS?.role_id
  const intl = useIntl();
  const profileData = useSelector((state: any) => state.GetProfileState);
  const user = profileData?.data?.data || Config?.USER_DETAILS;
  const needsSub = salonOwnerNeedsSubscription(user);
  const suspended = salonOwnerSubscriptionSuspended(user);
  const featureLocked = salonOwnerSubscriptionFeatureLocked(user);
  const expiredNavTitle = intl.formatMessage({
    id: 'subscription_expired_feature_tooltip',
    defaultMessage:
      'Your subscription has expired. Renew your plan to access this feature.',
  });
  const suspendedNavTitle = intl.formatMessage({
    id: 'subscription_suspended_feature_tooltip',
    defaultMessage:
      'Your subscription is suspended. Contact support or wait until an administrator restores access.',
  });
  const gatedNavTitle = suspended ? suspendedNavTitle : expiredNavTitle;

  const closeSidebar = () => {
    $(".leftsidebar").removeClass("active")
  }

  const splitPath = window.location.hostname === "localhost" ? location?.pathname.split('/') : Config?.url + location?.pathname

  const current_page_1 = window.location.hostname === "localhost" ? splitPath[1] : Config?.url + location?.pathname




  const isActive = (path: any) => {
    if (current_page_1.includes(path)) {
      return true;
    } else {
      return false;
    }
  }




  useEffect(() => {
    const handleClickAction = () => {
      $(".leftsidebar").removeClass("active");
    };
    $("#actionButton").on("click", handleClickAction);
    return () => {
      $("#actionButton").off("click", handleClickAction);
    };
  }, []);



  return (
    <>
      <aside>
        <div className='mobileHeader d-lg-none'>Menu <button type='button' onClick={() => { closeSidebar() }} className='btn mob-close'><span className="icon-close"></span></button></div>
        <ul id="actionButton">
          <li>
            <Link
              className={
                isActive("dashboard") || isActive("my-bookings") || isActive("change-password") || isActive("my-profile") || isActive("offline-booking")
                  ? "active"
                  : ""
              }
              to="/dashboard"
            >
              <span className="icon-home"></span>{" "}
              <FormattedMessage id="dashboard" />
            </Link>
          </li>
          <li>
            <Link className={isActive("subscription-plans") || isActive("subscription-purchase") ? 'active' : ''} to="/subscription-plans">
              <span className="icon-dollar"></span> <FormattedMessage id="subscription_plans_title" defaultMessage="Subscription" /></Link>
          </li>
          {
            !needsSub && role_id != 2 &&
            <li>
              <Link className={isActive("sales-growth-management") ? 'active' : ''} to="/sales-growth-management">
                <span className="icon-stats"></span> <FormattedMessage id="sales-growth-management" /></Link>
            </li>
          }

          {
            !needsSub && role_id != 2 &&
            <li>
              {featureLocked ? (
                <span className="sidebar-link-disabled" title={gatedNavTitle}>
                  <span className="icon-people"></span>{' '}
                  <FormattedMessage id="staff_member" />
                </span>
              ) : (
                <Link className={isActive("staff-member") || isActive("staff-member/update") || isActive("staff-member/view") ? 'active' : ''} to="/staff-member">
                  <span className="icon-people"></span> <FormattedMessage id="staff_member" /></Link>
              )}
            </li>
          }
          {!needsSub && <li>
            {featureLocked && role_id != 2 ? (
              <span className="sidebar-link-disabled" title={gatedNavTitle}>
                <span className="icon-service"></span>{' '}
                <FormattedMessage id="services_management" />
              </span>
            ) : (
              <Link className={isActive("service-update") || isActive("service-management") || isActive("service-management/view") || isActive("service") ? 'active' : ''} to="/service-management">
                <span className="icon-service"></span> <FormattedMessage id="services_management" /></Link>
            )}
          </li>}

          {
            !needsSub && role_id != 2 &&
            <li>
              <Link className={isActive("contact-support") ? 'active' : ''} to="/contact-support">
                <span className="icon-support"></span> <FormattedMessage id="customer_support" /></Link>
            </li>
          }
          {
            role_id == 2 && (
              <>
                <li>
                  <Link className={isActive("staff-availability") ? 'active' : ''} to="/staff-availability">
                    <span className="icon-available-calendar"></span> <FormattedMessage id="staff_availability_title" /></Link>
                </li>
              </>
            )
          }
          {
            !needsSub && role_id != 2 &&

            <li>
              <Link className={isActive("salon-availability") ? 'active' : ''} to="/salon-availability">
                <span className="icon-available-calendar"></span> <FormattedMessage id="salon_availability" /></Link>
            </li>
          }

          {
            !needsSub && role_id != 2 &&
            <li>
              <Link className={isActive("billing") ? 'active' : ''} to="/billing">
                <span className="icon-bill-receipt"></span> <FormattedMessage id="billing_management" /></Link>
                {/* <span className="icon-bill-receipt"></span> Billing Management</Link> */}
            </li>

          }



          {/* <li>
              <Link to="#">
              <span className="icon-service"></span> Services Management</Link>
            </li>
            <li>
              <Link to="#">
              <span className="icon-people"></span> Staff Member</Link>
            </li>
            <li>
              <Link to="#">
              <span className="icon-dollar"></span> Subscription</Link>
            </li>
            <li>
              <Link to="#">
              <span className="icon-bill-receipt"></span> Billing Management</Link>
            </li>
            <li>
              <Link to="#">
              <span className="icon-support"></span> Customer Support</Link>
            </li> */}


        </ul>
        <div className='logOut' onClick={logoutHelper}>
          <button className='btn logOUt' >
            <span className="icon-logout" ></span> <FormattedMessage id="logout" /></button>
          {/* <Link to="/">
            <span className="icon-logout" onClick={() => handleLogout()}></span> Logout</Link> */}
        </div>
      </aside>
    </>
  )
}

export default Sidebar
